export enum GoalType {
  RETIREMENT = 'RETIREMENT',
  BUILD_WEALTH = 'BUILD_WEALTH',
  MAJOR_PURCHASE = 'MAJOR_PURCHASE'
}

export enum GoalStatusType {
  COMPLETE = 'COMPLETE',
  DELETED = 'DELETED',
  FROZEN = 'FROZEN',
  GOOD = 'GOOD',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  NO_MODEL = 'NO_MODEL',
  NO_PORTFOLIO = 'NO_PORTFOLIO',
  SIMULATION = 'SIMULATION',
  NO_STATUS = 'NO_STATUS',
  PORTFOLIO_NO_ACCOUNT = 'PORTFOLIO_NO_ACCOUNT'
}

export class GoalStatusTypeHelper {
  static isGoalSetupComplete(status: GoalStatusType): boolean {
    return !(status === GoalStatusType.NO_MODEL || status === GoalStatusType.NO_PORTFOLIO || status === GoalStatusType.PORTFOLIO_NO_ACCOUNT);
  }

  static isGoalComplete(status: GoalStatusType): boolean {
    return status === GoalStatusType.COMPLETE;
  }
}

export enum DepositFrequency {
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY'
}

export enum LtiProvince {
  AB = 'AB',
  BC = 'BC',
  MB = 'MB',
  NB = 'NB',
  NF = 'NF',
  NL = 'NL',
  NS = 'NS',
  NT = 'NT',
  NU = 'NU',
  ON = 'ON',
  PE = 'PE',
  QC = 'QC',
  SK = 'SK',
  YT = 'YT'
}

export enum LtiAccountStatus {
  LTI_ELIGIBLE = 'LTI_ELIGIBLE',
  LTI_INELIGIBLE = 'LTI_INELIGIBLE',
  LTI_OCCUPIED = 'LTI_OCCUPIED',
  LTI_UNAVAILABLE = 'LTI_UNAVAILABLE',
  LTI_DO_NOT_DISPLAY = 'LTI_DO_NOT_DISPLAY'
}

export enum ProjectionUnitCode {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SIX_MONTHLY = 'SIX_MONTHLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}
